"use client";
import { SLChatButtonPlaceholder } from "@/components/buttons/SLChatButtonPlaceholder";
import { brevoConversationsId } from "@/lib/consts";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  ComponentWithChildrenProps,
  useBooleanState,
} from "@nvon/react-toolbox";
import Script from "next/script";
import React, { useEffect } from "react";
import { useConsentData } from "../TruendoConsentProvider";

export const SLBrevoChatProvider = ({
  children,
}: ComponentWithChildrenProps): React.JSX.Element => {
  const brevoChatAccepted = useConsentData().preferences;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });

  const { on: loadBrevoScript, state: isActive } = useBooleanState(() => {
    // Check if the script tag is already loaded.
    // This happens when switching from landingpage to app and vice versa.
    return (
      typeof document !== "undefined" &&
      document.querySelectorAll(`script#${scriptId}`).length > 0
    );
  });

  useEffect(
    function setBrevoConfig() {
      window.BrevoConversationsSetup = {
        startHidden: isMobile,
        onAnalyticEvent: () => {},
      };
    },
    [brevoChatAccepted, isMobile, loadBrevoScript],
  );

  useEffect(
    function loadScript() {
      if (brevoChatAccepted) {
        loadBrevoScript();
      }
    },
    [brevoChatAccepted, loadBrevoScript],
  );

  return (
    <>
      {isActive ? (
        <Script
          id={scriptId}
          dangerouslySetInnerHTML={{
            __html: `
                (function(d, w, c) {
                w.BrevoConversationsID = '${brevoConversationsId}';
                w[c] = w[c] || function() {
                    (w[c].q = w[c].q || []).push(arguments);
                };
                var s = d.createElement('script');
                s.async = true;
                s.src = 'https://conversations-widget.brevo.com/brevo-conversations.js';
                if (d.head) d.head.appendChild(s);
                })(document, window, 'BrevoConversations');
            `,
          }}
        />
      ) : (
        <SLChatButtonPlaceholder />
      )}

      {children}
    </>
  );
};

interface BrevoIntegrationData {
  email: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
}

/**
 * There' some more.
 * Just check the Brevo Objects at runtime to discover.
 */
declare global {
  interface Window {
    BrevoConversations: (
      action: string,
      value: boolean | BrevoIntegrationData,
    ) => void;
  }

  interface Window {
    BrevoConversationsSetup: {
      startHidden?: boolean;
      disableGaTracking?: boolean;
      onAnalyticEvent: (eventName: string) => void;
    };
  }
}

const scriptId = "brevoChat";
